import React from 'react';

const SvgIntrodutoryProject: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="introdutoryProject_svg__a">
          <path d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
      <g
        clipPath="url(#introdutoryProject_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 16.976L11.987 21M11.987 21L3 16.976M21 12l-9.013 4.024" />
      </g>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.987 16.024L3 12"
      />
      <g clipPath="url(#introdutoryProject_svg__a)">
        <path
          d="M3 7.024l8.987 4.024L21 7.024 12.013 3z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default SvgIntrodutoryProject;
